<template>
  <v-container fluid class="pa-0">

    <v-progress-linear v-if="ContractTypesLoading" indeterminate height="1"></v-progress-linear>
    <v-divider v-else style="border-color: rgb(151 151 151 / 12%);" />

    <RouteListItem v-for="(contractType, index) in ContractTypeList" :key="index" :node="{
      name: 'Contracts',
      meta: {
        displayName: contractType.Name,
        icon: 'mdi-' + contractType.Icon,
        count: contractType.Count,
        params: { contractTypeId: contractType.Id },
      }
    }">
    </RouteListItem>

    <v-divider class="mx-4" style="border-color: rgb(151 151 151 / 12%);" />

  </v-container>
</template>


<script>
import RouteListItem from "@/components/SingleUse/ComponentOverrides/sidebar/RouteListItem_Base.vue";

export default {
  name: "RouteListItem_ContractLists",
  props: {
    node: Object,
  },
  components: {
    RouteListItem,
  },

  data() {
    return {

    };
  },

  mounted() { },

  methods: {},

  computed: {
    ContractTypeList() {
      return this.$store.getters["LookUpStore/ContractTypeList"];
    },
    ContractTypesLoading() {
      return this.$store.getters["BackgroundUpdater/Loading"]("ContractTypeMap");
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>